var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ContractorEmployeeCard", {
    attrs: {
      avatar: _vm.contractorUser.avatar,
      givenName: _vm.contractorUser.given_name,
      familyName: _vm.contractorUser.family_name,
      employeeUserId: _vm.contractorUser.id,
      employeePageRouteParams: _vm.contractorPageRoute,
      companyName: _vm.contractorUser.profile.company_name,
      country: _vm.contractorUser.profile.country,
      city: _vm.contractorUser.profile.city,
      maxRate: _vm.contractorUser.profile.max_rate,
      minRate: _vm.contractorUser.profile.min_rate,
      jobTitle: _vm.contractorUser.profile.job_title,
      skills: _vm.contractorUser.profile.skills,
      available: _vm.contractorUser.available,
      userUpdatedDate: _vm.userUpdatedDate,
      nameBlockMinHeight: _vm.nameBlockMinHeightValue,
      skillsBlockMinHeight: _vm.skillsBlockMinHeightValue,
    },
    on: {
      "update:nameBlockMinHeight": function ($event) {
        _vm.nameBlockMinHeightValue = $event
      },
      "update:name-block-min-height": function ($event) {
        _vm.nameBlockMinHeightValue = $event
      },
      "update:skillsBlockMinHeight": function ($event) {
        _vm.skillsBlockMinHeightValue = $event
      },
      "update:skills-block-min-height": function ($event) {
        _vm.skillsBlockMinHeightValue = $event
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "avatarInfo",
          fn: function () {
            return [
              _c("CardRating", { attrs: { ratingTotal: _vm.ratingTotal } }),
            ]
          },
          proxy: true,
        },
        {
          key: "avatarSecondary",
          fn: function () {
            return [_vm._t("avatarSecondary")]
          },
          proxy: true,
        },
        {
          key: "nameBlock",
          fn: function ({ status, employeePageRouteParams }) {
            return [
              _vm._t("nameBlock", null, {
                status: status,
                employeePageRouteParams: employeePageRouteParams,
              }),
            ]
          },
        },
        {
          key: "avatarPrimary",
          fn: function () {
            return [_vm._t("avatarPrimary")]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _vm._t("content"),
              _vm.isEmailUnconfirmed
                ? _c(
                    "div",
                    { staticClass: "flex flex-wrap mb-4" },
                    [
                      _vm.isEmailUnconfirmed
                        ? _c("Badge", {
                            attrs: {
                              color: _vm.BadgeColor.WARNING,
                              value: _vm.emailStatusText,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "actions",
          fn: function () {
            return [
              _vm.isEmailUnconfirmed
                ? _c("ContractorResendInvitation", {
                    attrs: {
                      contractorId: _vm.contractor.id,
                      companyId: _vm.companyId,
                      invitedByUserId: _vm.currentUserId,
                      givenName: _vm.contractor.user.given_name,
                      familyName: _vm.contractor.user.family_name,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({
                            resendInvitation,
                            processing,
                            invitationResent,
                          }) {
                            return [
                              _c(
                                "InvitationSentTooltip",
                                {
                                  staticClass: "h-12",
                                  attrs: {
                                    disabled: !invitationResent,
                                    fullWidth: "",
                                  },
                                },
                                [
                                  _c("UiButton", {
                                    attrs: {
                                      buttonText: "Resend invitation",
                                      variant: "secondary",
                                      fullWidth: "",
                                      processing: processing,
                                      disabled: invitationResent,
                                    },
                                    on: { click: resendInvitation },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4163493960
                    ),
                  })
                : _vm._e(),
              _vm._t("actions"),
              _vm.isAccessGranted
                ? _c("AddContractorToProject", {
                    attrs: {
                      variant: "secondary",
                      fullWidthTrigger: "",
                      withoutIcon: "",
                      currentUserRole: _vm.currentUserRole,
                      companyId: _vm.companyId,
                      contractorId: _vm.contractor.id,
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }